import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/movie";
import { TYPE_LABELS } from "@/types/movie";

export default function MediaListItem({ item }: { item: MediaItem }) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 hover:bg-primary-50/50"
    >
      <div className="relative h-[104px] w-[74px] shrink-0 overflow-hidden rounded-md bg-background-200">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 在线观看`}
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <h3 className="truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-600">
            {item.title}
          </h3>
          <span className="shrink-0 rounded bg-secondary-100 px-1.5 py-0.5 text-[10px] font-medium text-secondary-800">
            {TYPE_LABELS[item.type]}
          </span>
        </div>
        <p className="mt-1 text-xs text-foreground-500">
          {item.year} · {item.region} · {item.genres.slice(0, 2).join("/")}
        </p>
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">{item.summary}</p>
        <div className="mt-2 flex items-center gap-3 text-xs">
          <span className="flex items-center gap-1 font-semibold text-accent-700">
            <i className="ri-star-fill"></i>
            {item.rating.toFixed(1)}
          </span>
          <span className="flex items-center gap-1 text-foreground-500">
            <i className="ri-fire-line"></i>
            热度 {item.popularity}
          </span>
        </div>
      </div>
    </Link>
  );
}